import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment-timezone';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { ModalServiceService } from "src/app/_services/modal-service.service";
import { UsersService } from 'src/app/_services/admin/users.service';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { SettingService } from 'src/app/_services/admin/setting.service';
import { ProfilesService } from 'src/app/_services/admin/profiles.service';
import { PermissionService } from 'src/app/auth/permission.service';
import { DeleteRecordService } from 'src/app/_services/delete-record.service';
import { LoadingBayModel, PERSISTANT_ITEM } from 'src/app/_models/global.data.model';
import { WebSocketsService } from 'src/app/_services/web-sockets.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ShiftsService } from 'src/app/_services/shifts.service';

@Component({
  selector: 'app-user-details-v2',
  standalone: false,
  templateUrl: './user-details-v2.component.html',
  styleUrl: './user-details-v2.component.scss'
})
export class UserDetailsV2Component extends SubscriptionUtil implements OnInit, OnDestroy {
  // open shifts tab
  @Output() viewShiftsClicked = new EventEmitter<void>();

  translate: any;
  profile: any;
  users: any[] = [];
  managerName: string = '-';
  photoUrl: string = '../../../../assets/svg/Avatar.svg';
  homeAddressDisplay: string = '-';
  officeAddressDisplay: string = '-';
  params: any = {};
  timezone: any;
  dateFormat: any;

  hideBaseOnPackage: any = {
    hierarchy: false,
    skill: false
  };
  currentPackage: any;
  addonFeature: any;
  orgSettings: any;
  googleEnable: any;
  microsoftEnable: any;
  calendlyEnable: any;
  isAdmin: boolean = false;
  loginHistory: any[] = [];
  assignedUserGroups: any[] = [];
  assignedUserSkills: any[] = [];
  photoMenuItems: any[] = [
  {
    label: 'Change Photo',
    icon: 'fa-regular fa-camera',
    command: () => this.openModal('uploadPhoto', this.profile)
  },
  {
    label: 'Remove Photo',
    icon: 'fa-regular fa-trash-can',
    command: () => this.removePhoto()
  }
];
  userShifts: any[] = [];
displayNewJO2: boolean = false;
displayNewWORKFLOW2: boolean = false;
  constructor(
    private languageTranslateService: LanguageTranslateService,
    private modalService: ModalServiceService,
    private userService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    public auth: AuthenticationService,
    private settingService: SettingService,
    private profileService: ProfilesService,
    private perm: PermissionService,
    private deleteRecordService: DeleteRecordService,
    private webSocket: WebSocketsService,
    private util: UtilServiceService,
    private shiftsService: ShiftsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.timezone = this.auth.getUserTimezone();
    this.hideBaseOnPackage.hierarchy = this.auth.getAddonPackageListsToHide('HIERARCHY');
    this.hideBaseOnPackage.skill = this.auth.getAddonPackageListsToHide('SKILLS');
    this.addonFeature = this.auth.getAddonFeatureLists();
    this.currentPackage = localStorage.getItem('packageCode');
    this.isAdmin = this.perm.capable('manage_users', 'read');
    this.dateFormat = localStorage.getItem("date_format");


    /***********End Check if the PMV3 package is old or new ***********/
          var tenantPackagesJO2 = this.auth.getPackageCodeWithList("JO2");
          if (localStorage.getItem("packageCode") == "Old") {
            this.displayNewJO2 = this.addonFeature.addonJO2 == "JO2" ? true : false;
          } else {
            if (this.auth.getAddonPackageListsToHide("JO2")) {
              this.displayNewJO2 =
                tenantPackagesJO2.addonPackageList == "JO2" ||
                this.addonFeature.addonJO2 == "JO2"
                  ? true
                  : false;
            } else {
            this.displayNewJO2 = false;
            }
          }


     /***********End Check if the WORKFLOW2 package is old or new ***********/
      var tenantPackagesWORKFLOW2 = this.auth.getPackageCodeWithList("WORKFLOW2");
      if (localStorage.getItem("packageCode") == "Old") {
        this.displayNewWORKFLOW2 = this.addonFeature.addonWORKFLOW2 == "WORKFLOW2" ? true : false;
      } else {
        if (this.auth.getAddonPackageListsToHide("WORKFLOW2")) {
          this.displayNewWORKFLOW2 = tenantPackagesWORKFLOW2.addonPackageList == "WORKFLOW2" || this.addonFeature.addonWORKFLOW2 == "WORKFLOW2"
              ? true
              : false;
        } else {
          this.displayNewWORKFLOW2 = false;
        }
      }

      
    this.push(
      this.settingService.getOrgSettings(1).subscribe((res: any) => {
        this.orgSettings = res;
      })
    );

    this.getLanguageData();
    this.subscribeIntegrationRefresh();

    this.push(
      this.route.queryParams.subscribe((params: any) => {
        if (params.id) {
          this.params = params;
          this.loadUserData(params.id);
        } else {
          this.params = { id: this.auth.getUserId() };
          this.loadUserData(this.params.id);
        }
      })
    );
  }

  /** Refresh details after connect/disconnect (modal emit + calendar events) */
  private subscribeIntegrationRefresh() {
    this.push(
      this.userService.refreshList$.subscribe(() => {
        this.reloadUserDetails();
      })
    );

    this.push(
      this.profileService.refreshProfilePhoto$.subscribe((res: any) => {
        const uploadedUrl = res?.attachmentUrl || res?.body?.attachmentUrl;
        if (uploadedUrl) {
          this.setPhotoUrl(uploadedUrl, true);
        }
        this.reloadUserDetails();
      })
    );

    this.push(
      this.webSocket.refreshGCelenderMessages$.subscribe(() => {
        this.reloadUserDetails();
      })
    );

    this.push(
      this.userService.refreshGoogleCalender$.subscribe(() => {
        this.reloadUserDetails();
      })
    );

    this.push(
      this.userService.refreshMicrosoftCalender$.subscribe(() => {
        this.reloadUserDetails();
      })
    );

    this.push(
      this.userService.refreshCalendlyCalender$.subscribe(() => {
        this.reloadUserDetails();
      })
    );
  }

  private reloadUserDetails() {
    const userId = this.params?.id || this.profile?.id;
    if (!userId) {
      return;
    }
    this.loadUserData(userId);
  }

  private setPhotoUrl(url?: string, bustCache = false) {
    if (!url) {
      this.photoUrl = '../../../../assets/svg/Avatar.svg';
      return;
    }
    if (!bustCache) {
      this.photoUrl = url;
      return;
    }
    const separator = url.includes('?') ? '&' : '?';
    this.photoUrl = `${url}${separator}t=${Date.now()}`;
  }

  /********************************** Load user data **************************/
  loadUserData(id: any) {
    this.push(
      this.userService.getUserProfile(id).subscribe((profile: any) => {
        this.profile = profile;
        this.setPhotoUrl(profile?.imageUrl, true);
        this.homeAddressDisplay = this.buildAddressDisplay([
          profile?.homeStreet,
          profile?.homeCity,
          profile?.homeState,
          profile?.homePostcode,
          profile?.homeCountry,
        ]);
        this.officeAddressDisplay = this.buildAddressDisplay([
          profile?.officeStreet,
          profile?.officeCity,
          profile?.officeState,
          profile?.officePostcode,
          profile?.officeCountry,
        ]);
        this.resolveManagerName();

        if (this.profile?.userCalendar != null) {
          this.getCalendarData();
        }

        if (profile?.profileId) {
          this.loadProfileIntegrations(profile.profileId);
        }
        if (profile?.login) {
          this.loadLoginHistory(profile.login);
        } else {
          this.loginHistory = [];
        }

        this.loadAssignedUserGroups(id);
        this.loadAssignedUserSkills(id);
        this.loadUserShifts(id);
      })
    );

    this.push(
      this.userService.getAllUsers().subscribe((users: any) => {
        users.forEach((user: any) => {
          user.fullName = (user.firstName || '') + ' ' + (user.lastName || '');
        });
        this.users = users;
        this.resolveManagerName();
      })
    );
  }

  /************************************************** Working hours calendar (same as view-user) *******************************************/
  getCalendarData() {
    let calendar: any = new LoadingBayModel();
    calendar = {
      monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false, sunday: false,
      mondayAllDay: false, tuesdayAllDay: false, wednesdayAllDay: false, thursdayAllDay: false, fridayAllDay: false, saturdayAllDay: false, sundayAllDay: false,
      mondayStart: null, mondayEnd: null, tuesdayStart: null, tuesdayEnd: null, wednesdayStart: null, wednesdayEnd: null,
      thursdayStart: null, thursdayEnd: null, fridayStart: null, fridayEnd: null, saturdayStart: null, saturdayEnd: null,
      sundayStart: null, sundayEnd: null,
    };

    for (let j = 0; j <= this.profile.userCalendar.length - 1; j++) {
      let startWorkHour: any = null;
      let endWorkHour: any = null;
      if (this.profile.userCalendar[j].startWorkHour && this.profile.userCalendar[j].endWorkHour) {
        const startMomentTime = moment(moment().format('MM-DD-YYYY') + ' ' + this.profile.userCalendar[j].startWorkHour);
        const startMoment2 = moment.tz(startMomentTime, this.auth.getUserTimezone());
        startWorkHour = new Date(startMoment2.toDate());

        const pickUpstartWorkHour = moment(moment().format('MM-DD-YYYY') + ' ' + this.profile.userCalendar[j].endWorkHour);
        endWorkHour = new Date(pickUpstartWorkHour.toDate());
      }

      if (this.profile.userCalendar[j].workDay === 'MONDAY') {
        calendar.mondayStart = startWorkHour;
        calendar.mondayEnd = endWorkHour;
        if (!calendar.mondayStart || !calendar.mondayEnd) {
          calendar.mondayAllDay = true;
        }
        calendar.monday = true;
      } else if (this.profile.userCalendar[j].workDay === 'TUESDAY') {
        calendar.tuesdayStart = startWorkHour;
        calendar.tuesdayEnd = endWorkHour;
        if (!calendar.tuesdayStart || !calendar.tuesdayEnd) {
          calendar.tuesdayAllDay = true;
        }
        calendar.tuesday = true;
      } else if (this.profile.userCalendar[j].workDay === 'WEDNESDAY') {
        calendar.wednesdayStart = startWorkHour;
        calendar.wednesdayEnd = endWorkHour;
        if (!calendar.wednesdayStart || !calendar.wednesdayEnd) {
          calendar.wednesdayAllDay = true;
        }
        calendar.wednesday = true;
      } else if (this.profile.userCalendar[j].workDay === 'THURSDAY') {
        calendar.thursdayStart = startWorkHour;
        calendar.thursdayEnd = endWorkHour;
        if (!calendar.thursdayStart || !calendar.thursdayEnd) {
          calendar.thursdayAllDay = true;
        }
        calendar.thursday = true;
      } else if (this.profile.userCalendar[j].workDay === 'FRIDAY') {
        calendar.fridayStart = startWorkHour;
        calendar.fridayEnd = endWorkHour;
        if (!calendar.fridayStart || !calendar.fridayEnd) {
          calendar.fridayAllDay = true;
        }
        calendar.friday = true;
      } else if (this.profile.userCalendar[j].workDay === 'SATURDAY') {
        calendar.saturdayStart = startWorkHour;
        calendar.saturdayEnd = endWorkHour;
        if (!calendar.saturdayStart || !calendar.saturdayEnd) {
          calendar.saturdayAllDay = true;
        }
        calendar.saturday = true;
      } else if (this.profile.userCalendar[j].workDay === 'SUNDAY') {
        calendar.sundayStart = startWorkHour;
        calendar.sundayEnd = endWorkHour;
        if (!calendar.sundayStart || !calendar.sundayEnd) {
          calendar.sundayAllDay = true;
        }
        calendar.sunday = true;
      }
    }
    this.profile.calendar = calendar;
    this.profile.userCalendar = calendar;
  }
  /************************************************** End Working hours calendar *******************************************/
  private loadProfileIntegrations(profileId: any) {
    this.push(
      this.profileService.getProfileById(profileId).subscribe((profileData: any) => {
        this.googleEnable = null;
        this.microsoftEnable = null;
        this.calendlyEnable = null;
        profileData?.profileIntegrationAccessList?.forEach((element: any) => {
          if (element.tenantIntegrationConfig.integrationType == 'GOOGLE_CALENDAR') {
            this.googleEnable = element;
          }
          if (element.tenantIntegrationConfig.integrationType == 'MICROSOFT_OUTLOOK') {
            this.microsoftEnable = element;
          }
          if (element.tenantIntegrationConfig.integrationType == 'CALENDLY') {
            this.calendlyEnable = element;
          }
        });
      })
    );
  }

  private loadLoginHistory(login: string) {
    this.push(
      this.userService.getUserLoginActivities(login).subscribe((res: any) => {
        const rows = Array.isArray(res) ? res : (res?.content || res?.data || []);
        this.loginHistory = rows.map((item: any) => ({
          loginDate: item.loginDate,
          ipAddress: item.ipAddress || item.ip || '-',
          deviceId: item.deviceId || item.device || '-',
        }));
      })
    );
  }

  private loadAssignedUserGroups(userId: any) {
    this.push(
      this.userService.getUserUserGroups(userId).subscribe((res: any) => {
        const rows = Array.isArray(res) ? res : (res?.content || res?.data || res?.userGroups || []);
        this.assignedUserGroups = rows;
        if (this.profile) {
          this.profile.userGroups = rows;
          this.profile.userGroupIds = rows.map((g: any) => g?.id != null ? g.id : g);
        }
      })
    );
  }

  private loadAssignedUserSkills(userId: any) {
    this.push(
      this.userService.getUserSkills(userId).subscribe((res: any) => {
        const rows = Array.isArray(res) ? res : (res?.content || res?.data || res?.skills || res?.userDynamicSkillList || []);
        this.assignedUserSkills = rows;
        if (this.profile) {
          this.profile.userDynamicSkillList = rows;
        }
      })
    );
  }
/************************************************** Shifts Start *******************************************/
  viewShifts() {
    this.viewShiftsClicked.emit();
  }
  private loadUserShifts(userId: any) {
    this.push(
      this.shiftsService.getApplicableShiftAssignments(userId).subscribe(
        (res: any) => {
          const body = res?.body ?? res ?? {};
          const list = body.content ?? body.data ?? (Array.isArray(body) ? body : []);
          this.userShifts = (Array.isArray(list) ? list : [])
            .map((item: any) => this.mapShiftRow(item))
            .filter((row: any) => row.shiftTypeStatus === 'ACTIVE')
            .slice(0, 5);
        },
        () => {
          this.userShifts = [];
        }
      )
    );
  }

  private mapShiftRow(item: any) {
    const shiftTypeStatusRaw = String(
      item.shiftTypeStatus || item.shiftType?.status || item.status || item.assignmentStatus || 'ACTIVE'
    ).toUpperCase();
    const start = item.effectiveStartDate || item.effStart || item.startDate;
    const end = item.effectiveEndDate || item.effEnd || item.endDate;

    return {
      shiftType: item.shiftTypeName || item.shiftType?.name || item.shiftType || '—',
      effStart: this.formatShiftDate(start),
      effEnd: this.formatShiftDate(end),
      shiftTypeStatus: shiftTypeStatusRaw === 'ACTIVE' ? 'ACTIVE' : 'INACTIVE',
    };
  }

  private formatShiftDate(value: any): string {
    if (!value) {
      return '—';
    }
    const timezone = this.timezone || this.auth.getUserTimezone();
    const m = moment.tz(value, timezone);
    if (!m.isValid()) {
      return String(value);
    }
    const dateFormat =
      (this.dateFormat || localStorage.getItem('date_format') || 'YYYY-MM-DD').toUpperCase();
    return m.format(dateFormat);
  }
  /************************************************** Shifts End *******************************************/

  get hasUserGroups(): boolean {
    return !!(this.assignedUserGroups?.length);
  }

  get hasSkills(): boolean {
    return !!(this.assignedUserSkills?.length);
  }

  getSkillChipStyles(skill: any) {
    const background = skill?.colorCode || '#DDF3DD';
    const textColor =  skill?.textColor ||
      (skill?.color && skill.color !== background ? skill.color : null) ||
      this.darkenHexColor(background, 0.45);

    return {
      color: textColor,
      'background-color': background,
    };
  }

  private darkenHexColor(hex: string, amount: number = 0.4): string {
    if (!hex || typeof hex !== 'string') {
      return '#3B8B3B';
    }

    let cleaned = hex.trim().replace('#', '');
    if (cleaned.length === 3) {
      cleaned = cleaned.split('').map((c) => c + c).join('');
    }
    if (!/^[0-9a-fA-F]{6}$/.test(cleaned)) {
      return '#3B8B3B';
    }

    const num = parseInt(cleaned, 16);
    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;

    r = Math.max(0, Math.floor(r * (1 - amount)));
    g = Math.max(0, Math.floor(g * (1 - amount)));
    b = Math.max(0, Math.floor(b * (1 - amount)));

    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
  }

  removeUserGroup(group: any) {
    const userId = this.params?.id || this.profile?.id;
    const groupId = group?.id != null ? group.id : group;
    if (!userId || groupId == null) {
      return;
    }

    const groupName = group?.name || '';
    this.deleteRecordService.getItems({
      deleteType: 'Remove User Group',
      deleteHeader: 'Remove User from Group',
      deleteIconType: 'confirm',
      message: groupName
        ? `Are you sure you want to remove this user from the group "${groupName}"?`
        : 'Are you sure you want to remove this user from the group?',
      userId,
      groupId,
      id: groupId,
    });
  }

  get hasAnyIntegrationEnabled(): boolean {
    return !!(this.googleEnable?.enabled || this.microsoftEnable?.enabled || this.calendlyEnable?.enabled);
  }

  get setupAccessModalData(): any {
    return {
      profile: this.profile,
      orgSettings: this.orgSettings,
      currentPackage: this.currentPackage,
      addonFeature: this.addonFeature,
    };
  }

  private resolveManagerName() {
    if (!this.profile?.superVisorId || !this.users?.length) {
      this.managerName = this.profile?.superVisorName || '-';
      return;
    }
    const manager = this.users.find((u: any) => u.id == this.profile.superVisorId);
    this.managerName = manager
      ? (manager.fullName || (manager.firstName + ' ' + manager.lastName))
      : (this.profile?.superVisorName || '-');
  }

  private buildAddressDisplay(parts: any[]): string {
    const filtered = parts.filter((p) => p !== null && p !== undefined && p !== '');
    return filtered.length ? filtered.join(', ') : '-';
  }
  /********************************** End Load user data **************************/

  /********************************** Start Language **************************/
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
      }
    }));
  }
  /********************************** End Language **************************/

  /********************************** Start Open Modal **************************/
  openModal(modalView: any, data: any) {
    this.modalService.openModal(modalView, data);
  }

  /** Same confirm flow as view-user openModal3 for activate/suspend/deactivate */
  openStatusAction(modalView: any) {
    if (modalView === 'activateUser') {
      this.profile.deleteType = 'Activate User Profile';
      this.profile.deleteHeader = this.translate?.setup.users.users.messages.activateUserProfile;
      this.profile.deleteIconType = 'confirm';
      this.profile.message = this.translate?.contacts.messages.confirmActivateUser;
      this.deleteRecordService.getItems(this.profile);
    } else if (modalView === 'deactivateUser') {
      this.profile.deleteType = 'Deactivate User Profile';
      this.profile.deleteHeader = this.translate?.setup.users.users.messages.deactivateUserProfile;
      this.profile.deleteIconType = 'confirm';
      this.profile.message = this.translate?.contacts.messages.confirmDeactivateUser;
      this.deleteRecordService.getItems(this.profile);
    } else if (modalView === 'suspendUser') {
      this.profile.deleteType = 'Suspend User Profile';
      this.profile.deleteHeader = this.translate?.setup.users.users.messages.suspendUserProfile;
      this.profile.deleteIconType = 'confirm';
      this.profile.message = this.translate?.contacts.messages.confirmSuspendUser;
      this.deleteRecordService.getItems(this.profile);
    }
  }

  removePhoto() {
    this.profile.deleteType = 'Profile picture';
    this.profile.deleteHeader = this.translate?.setup.users.users.messages.profilePicture;
    this.deleteRecordService.getItems(this.profile);
  }
  resetPassword() {
    console.log(this.profile);
    if (this.profile.id == this.auth.getUserId()) {
      this.modalService.openModal("resetPassword", this.profile);
    } else {
      this.modalService.openModal( "confirmResetPassword", this.profile );
    }
  }

  get isOwnProfile(): boolean {
    const userId = this.params?.id || this.profile?.id;
    return userId != null && String(userId) === String(this.auth.getUserId());
  }

  get canEditUser(): boolean {
    return this.isOwnProfile || this.perm.capable('manage_users', 'update');
  }

  goToEditUser() {
    const userId = this.params?.id || this.profile?.id;
    if (!userId || !this.canEditUser) {
      return;
    }
    this.router.navigate(['/dashboard/setup/allUser/updateUser'], {
      queryParams: { id: userId },
    });
  }

  onClickIntegrations() {
    this.router.navigate(['dashboard/setup/integration/config']);
  }

  viewAccessProfile() {
    const profileId = this.profile?.profileId;
    if (!profileId) {
      return;
    }
    localStorage.removeItem('activeIndexAccess');
    this.util.setPersistantItem(PERSISTANT_ITEM.ACCESS, { disabled: true });
    this.router.navigate(['dashboard/setup/profiles/view/' + profileId], {
      queryParams: { id: profileId },
    });
  }
  /********************************** End Open Modal **************************/

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
